import { runtime } from '../../classes/runtime/Runtime';
import { PersonalTopicControl } from '../../server/control/PersonalTopicControl';
import { UserControl } from '../../server/control/UserControl';
import { TopicControl } from '../../server/control/TopicControl';
import { QuestionControl } from '../../server/control/QuestionControl';
import { AudioControl } from '../../server/control/AudioControl';
import { AdminControl } from '../../server/control/AdminControl';
import { EditControl } from '../../server/control/EditControl';
import { VideoControl } from '../../server/control/VideoControl';
import { RaceControl } from '../../server/control/RaceControl';
import { AnswerControl } from '../../server/control/AnswerControl';
import { EntityControl } from '../../server/control/EntityControl';
import { AuthControl } from '../../server/control/AuthControl';
import { PrismaService } from '../../server/service/PrismaService';
import { PrismaControl } from '../../server/control/PrismaControl';

class Xa {
  xaProxy(classifier): any {
    return new Proxy(this, {
      get(xa, command: string) {
        return data => xa.run_xa(classifier, command, data);
      },
    });
  }


  async run_xa(classifier, command, data) {
    const response = await runtime.axios.post(
      `${runtime.isServerRuntime ? `https://${runtime.stagePrefix}.schlaukopf.de` : ''
      }/api/xa/${classifier}/${command}`,
      {
        classifier,
        command,
        data,
        pageHref: window !== 'undefined' && decodeURI(window.location.href),
      },
    );

    const reply = response.data ? response.data.payload : undefined;
    if (runtime.isServerRuntime && runtime.isDevelopmentStage || window.location.host.startsWith('dev.')) {
      // console.log(`xa reply for ${classifier}_${command}`, reply);
    }
    return reply;
  }

  auth: AuthControl = this.xaProxy('auth');
  user: UserControl = this.xaProxy('user');
  personalTopic: PersonalTopicControl = this.xaProxy('personalTopic');
  topic: TopicControl = this.xaProxy('topic');
  question: QuestionControl = this.xaProxy('question');
  answer: AnswerControl = this.xaProxy('answer');
  audio: AudioControl = this.xaProxy('audio');
  video: VideoControl = this.xaProxy('video');
  admin: AdminControl = this.xaProxy('admin');
  edit: EditControl = this.xaProxy('edit');
  race: RaceControl = this.xaProxy('race');
  entity: EntityControl = this.xaProxy('entity');
  prisma: PrismaControl = this.xaProxy('prisma');




}

export const xa = new Xa();
